import { Image, notification, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";

/* eslint-disable-next-line */
export interface UploadImageProps {
  image: string;
  setImage: (image: string) => void;
}

export function UploadImage(props: UploadImageProps) {
  const {
    image,
    setImage,
  } = props;
  return (
    <>
      {image && <Image src={`/${image}`}/>}
      <Upload.Dragger
        name='file'
        multiple={false}
        showUploadList={false}
        action={'/api/image'}
        onChange={(info) => {
          const { status } = info.file;
          if (status !== 'uploading') {
            console.log(info.file, info.fileList);
          }
          if (status === 'done') {
            setImage(info?.file?.response?.data || '');
            notification.success({
              message: 'File uploaded successfully',
              description: info?.file?.response?.data,
            });
          } else if (status === 'error') {
            notification.error({
              message: 'File upload failed',
              description: info.file.name,
            });
          }
        }}
        onDrop={(e) => {
          console.log('Dropped files', e.dataTransfer.files);
        }}
      >
        {image ? (
          <p className="ant-upload-drag-icon">
            <InboxOutlined/>
            <br />
            Change file
          </p>
        ) : (
          <>
            <p className="ant-upload-drag-icon">
              {image ? <img className='image-preview' src={`/${image}`} alt="alt"/> : <InboxOutlined/>}
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">
              Support for a single or bulk upload. Strictly prohibited from uploading company data or other
              banned files.
            </p>
          </>
        )}
      </Upload.Dragger>
    </>
  );
}

export default UploadImage;
